define('home/mixins/withReason',[
    'underscore',
    'home/views/ActivityActorsHoverCard',
    'core/utils',

], function (
    _,
    ActivityActorsHoverCard,
    utils
) {
    'use strict';

    var initHoverCard = function () {
        // We don't use voter cards on mobile-like user agents.
        if (utils.isMobileUserAgent())
            return;

        var target = this.$('[data-role=actors]');
        if (!target.length)
            return;

        if (this.hoverCard)
            this.hoverCard.remove();

        this.hoverCard = ActivityActorsHoverCard.create({
            targetElement: target,
            activityFeedItem: this.model,
            activityId: this.model.id,

            // The avatar for 1 actor is shown in the reason line. Other actors
            // are shown as "n other(s)"
            numShownActors: 1,
        });
    };

    /*
     * Returns the number of times this action occurred.
     * For right now, we only show a count if there was only 1 actor
     * and more than 1 occurrence.
     * ex: Nicole commented 2 times
     */
    var getNumOccurrences = function () {
        if (!this.model.actors || this.model.actors.length !== 1)
            return 0;

        var numOccurrences = this.model.get('totalActivities');
        return numOccurrences > 1 ? numOccurrences : 0;
    };

    var withReason = function () {
        this.initialize = _.wrap(this.initialize, function (_initialize) {
            _initialize.apply(this, _.rest(arguments));

            // Whenever this view (re)renders, reinitialize the hovercard so the
            // event handlers are tied to the correct elements.
            this.listenTo(this, 'render', initHoverCard);
        });

        var _templateHelpers = this.templateHelpers;
        this.templateHelpers = function () {
            var enableBestOfDisqusCallout = this.options && this.options.enableBestOfDisqusCallout;
            var thread = this.model.thread;
            var firstActivity = this.model.activities[0];
            var isBestOfDisqus = enableBestOfDisqusCallout &&
                firstActivity.get('type') === 'TrendingThreadOnChannel' &&
                (firstActivity.targetChannel && firstActivity.targetChannel.get('options').isCurationOnlyChannel);

            return _.extend({
                relativeTime: this.model.getRelativeTimestamp(),
                numRemainingActors: this.model.get('totalActors') - 1,
                numOccurrences: getNumOccurrences.call(this),
                firstActor: this.model.actors[0] && this.model.actors[0].toJSON(),
                isBestOfDisqus: isBestOfDisqus,

                // If thread was recommended by "Best of Disqus" add that as one "like".
                // (mainly makes a difference when there are 0 other likes)
                threadLikes: thread && thread.get('likes') + (isBestOfDisqus ? 1 : 0),
            }, _.isFunction(_templateHelpers) ? _templateHelpers.apply(this, arguments) : _templateHelpers);
        };
    };

    return withReason;
});


